module.exports = __webpack_public_path__ + "static/media/hat-winter.b3e0bf6c.svg";